module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-146.8ed1e6d2.jpg";